import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import BG1 from "./files/bg1.js";
import BG2 from "./files/bg2.js";
import styles from "./solutions.module.css";
import solutionsGlobal from "./solutionsGlobal.css";

class SolutionsSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div>
          Наша компания оказывает услуги по автоматизации и диспетчеризации в
          промышленности.
        </div>
        <br />
        <div style={{ fontWeight: "600" }}>
          Основные направления деятельности:
        </div>
        <br />
        <br />
        <div style={{ display: "flex", textAlign: "center" }}>
          <div style={{ flex: "1" }} className={styles.bgTextContainer}>
            <Link to="/solutions1">
              <div className={styles.iconTextContainer}>
                <div
                  className={styles.iconContainer}
                  style={{
                    backgroundImage: <BG1 />,
                    backgroundColor: "transparent"
                  }}
                >
                  <div className={styles.BGImg1}>
                    <BG1 />
                  </div>
                </div>
                <div style={{ marginTop: "4%", textAlign: "left" }}>
                  <span style={{ paddingLeft: "26.5%", fontWeight: "600" }}>
                    Автоматизированные системы
                  </span>
                </div>
                <div style={{ textAlign: "left" }}>
                  <span style={{ paddingLeft: "15.5%", fontWeight: "600" }}>
                    коммерческого учета энергоресурсов (АСКУЭ)
                  </span>
                </div>
              </div>
            </Link>
          </div>
          <div style={{ flex: "1" }} className={styles.bgTextContainer}>
            <Link to="/solutions2">
              <div className={styles.iconTextContainer}>
                <div
                  className={styles.iconContainer}
                  style={{
                    backgroundImage: <BG2 />
                    //backgroundColor: "transparent"
                  }}
                >
                  <div className={styles.BGImg2}>
                    <BG2 />
                  </div>
                </div>
                <div style={{ marginTop: "4%", textAlign: "left" }}>
                  <span style={{ paddingLeft: "31.5%", fontWeight: "600" }}>
                    Системы мониторинга и
                  </span>
                </div>
                <div style={{ textAlign: "left" }}>
                  <span style={{ paddingLeft: "32.5%", fontWeight: "600" }}>
                    управления объектами
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <br />
        <div style={{ fontWeight: "600" }}>Виды услуг:</div>
        <ul className="globalSolutionsUlList">
          <li style={{ display: "list-item" }}>проектирование</li>
          <li style={{ display: "list-item" }}>
            разработка и поставка программного обеспечение
          </li>
          <li style={{ display: "list-item" }}>
            разработка и поставка аппаратного обеспечение
          </li>
          <li style={{ display: "list-item" }}>
            внедрение и сопровождение аппаратно-программных комплексов
          </li>
        </ul>
        <br />
        <div>
          ООО "Теплоинформ" является одним из организаторов ежегодного семинара
          "Диспетчеризация Учёта и Контроля тепловой энергии, отпущенной
          абонентам и сопутствующие задачи".
        </div>
      </div>
    );
  }
}

export default SolutionsSlide;
